import {
    StyleSheet
} from "react-native";

export default StyleSheet.create({
    headerWrapper: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerButton: {
        alignSelf: "flex-start"
    },
    coverImageWrapper: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    coverImage: {
        height: 250,
        width: "100%"
    },
    tagWrapper: {
        position: "absolute"
    }
});
